module.exports = __webpack_public_path__ + "img/tk.02f4076e.svg";